module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAPCAYAAAAPr1RWAAABB0lEQVQ4je3TsUoDQRSF4U9JY2GVUhBR8BECxs5Oi4hWooWlEMsF9RFUSGlqG8HKIhY2YqngI1jkAYRgaypl4G5YQjYmdoKn2rnn3J+dOzP+NUozeS3LsgYOcIjPX0xrDte4abVanVSoFMwjbGEB2+hNAa4iAeuYj2+zhcAubrGOZyxPCF6JfD36d3KjCO9jHxdYxQtqP4BrAU75y+jvj4InfeEMx7HVJzRKwI3wq5E/jf6BhuG52oXt3aE55DejLsbZHgUpgyfdYyMO9irGlfLnse6F3ykDVMqM0CvW8IAT7GERb9hEd1zzuD/P1Y2b8B7gj1iPBU8KT0ojWMJjvINp3sBfE74Bz9kwtC5rCOsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_dropdown@2x.png
// module id = nB89
// module chunks = 1